import script from "./GlobalSuccessDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalSuccessDialog.vue?vue&type=script&setup=true&lang=js"

import "./GlobalSuccessDialog.vue?vue&type=style&index=0&id=268c5964&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-268c5964"]])

export default __exports__